/* EXO NAD+ Theme – kleine Helfer (Galerie, Mengenpreis, Warenkorb) */
(function () {
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'de', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  // Galerie
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var main = g.querySelector('[data-gallery-main]');
    g.querySelectorAll('.gallery__thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = btn.getAttribute('data-src');
        g.querySelectorAll('.gallery__thumb').forEach(function (b) { b.removeAttribute('aria-current'); });
        btn.setAttribute('aria-current', 'true');
      });
    });
  });

  // Produktformular mit Mengenpreis
  document.querySelectorAll('[data-product-form]').forEach(function (form) {
    var qtyInput = form.querySelector('[data-qty-input]');
    var variantInput = form.querySelector('[data-variant-input]');
    var tiers = (form.getAttribute('data-tiers') || '').split(',').filter(Boolean).map(function (t) { var p = t.split(':'); return { q: parseInt(p[0], 10), p: parseInt(p[1], 10), v: p[2] ? parseInt(p[2], 10) : null }; }).sort(function (x, y) { return x.q - y.q; });
    var hasTier = form.getAttribute('data-has-tier') === 'true' && tiers.length > 0;
    var currency = form.getAttribute('data-currency');
    var radios = form.querySelectorAll('[data-tier-qty]');
    var unitTop = document.querySelector('[data-unit-price]');
    var swapImg = false;
    var focusAddon = false;

    function basePrice() {
      if (!variantInput) return 0;
      if (variantInput.tagName === 'SELECT') {
        var o = variantInput.options[variantInput.selectedIndex];
        return parseInt(o.getAttribute('data-price'), 10) || 0;
      }
      return parseInt(variantInput.getAttribute('data-price'), 10) || 0;
    }

    function unitFor(q, base) {
      var u = base;
      tiers.forEach(function (t) { if (q >= t.q && t.p < u) u = t.p; });
      return u;
    }
    function variantFor(q) {
      var v = null;
      tiers.forEach(function (t) { if (q >= t.q && t.v) v = t.v; });
      return v || parseInt(variantInput.value, 10);
    }

    function update() {
      var anyAddon = Array.prototype.some.call(form.querySelectorAll('[data-addon]'), function (a) { return a.checked; });
      var minQ = (qtyInput.getAttribute('data-min') === '0' && anyAddon) ? 0 : 1;
      var raw = parseInt(qtyInput.value, 10);
      var q = Math.max(minQ, isNaN(raw) ? 1 : raw);
      if (String(q) !== qtyInput.value) qtyInput.value = q;
      var bp = form.querySelector('[data-box-part]'); if (bp) bp.hidden = q === 0;
      var base = basePrice();
      var unit = hasTier ? unitFor(q, base) : base;
      var set = function (sel, txt) { var el = form.querySelector(sel); if (el) el.textContent = txt; };
      set('[data-box-text]', q + ' × ' + (q === 1 ? 'Box' : 'Boxen') + ' EXO NAD+ à ' + money(unit, currency));
      set('[data-box-sum]', money(unit * q, currency));
      var addonSum = 0, addonNames = [];
      form.querySelectorAll('[data-addon]').forEach(function (a) {
        if (a.checked) { addonSum += parseInt(a.getAttribute('data-price'), 10) || 0; addonNames.push('1 × ' + a.getAttribute('data-title').replace(/^\+\s*/, '')); }
      });
      var al = form.querySelector('[data-addon-line]');
      if (al) { al.hidden = !addonNames.length; set('[data-addon-text]', addonNames.join(', ')); set('[data-addon-sum]', money(addonSum, currency)); }
      set('[data-total]', money(unit * q + addonSum, currency));
      // Ansicht: Pen im Fokus (zuletzt angeklickt oder ohne Boxen) oder Boxen
      var adSel = form.querySelector('[data-addon]:checked');
      var addonView = !!adSel && (q === 0 || focusAddon);
      if (unitTop) unitTop.textContent = money(addonView ? (parseInt(adSel.getAttribute('data-price'), 10) || 0) : (q > 0 ? unit : base), currency);
      var tMain = document.querySelector('[data-price-text-main]'), tAdd = document.querySelector('[data-price-text-addon]');
      if (tAdd && tMain) { tAdd.hidden = !addonView; tMain.hidden = addonView; }
      var thMain = document.querySelector('[data-thumbs-main]'), thAdd = document.querySelector('[data-thumbs-addon]');
      if (thAdd) { thAdd.hidden = !addonView; if (thMain) thMain.hidden = addonView; }
      var sn = document.querySelector('[data-ship-note]');
      if (sn) {
        var fq = parseInt(sn.getAttribute('data-free-qty'), 10) || 0;
        var fv = parseInt(sn.getAttribute('data-free-value'), 10) || 0;
        var sum = unit * q + addonSum;
        var free = (fq > 0 && q >= fq) || (fv > 0 && sum >= fv);
        var url = sn.getAttribute('data-ship-url');
        sn.innerHTML = free ? '<strong style="color:var(--c-primary)">Lieferung versandkostenfrei</strong>' : 'zzgl. ' + (url ? '<a href="' + url + '">Versand</a>' : 'Versand');
      }
      var hint = form.querySelector('[data-hint]');
      if (hint) {
        var next = null;
        if (hasTier) tiers.forEach(function (t) { if (!next && t.q > q && t.p < unit) next = t; });
        var parts = [];
        if (hasTier && unit < base) parts.push('Mengenpreis aktiv – Sie sparen ' + money((base - unit) * q, currency) + '.');
        if (q === 0) { parts.push('Tipp: EXO NAD+ als Booster dazu – einfach eine Menge wählen.'); }
        else if (next) { var d = next.q - q; parts.push('Noch ' + d + ' Box' + (d === 1 ? '' : 'en') + ' bis ' + money(next.p, currency) + ' pro Box.'); }
        hint.textContent = parts.join(' ');
      }
      var active = null;
      radios.forEach(function (r) { r.checked = parseInt(r.value, 10) === q; if (parseInt(r.value, 10) <= q) active = r; });
      // Hauptbild passend zur gewählten Menge
      var img = active && active.closest('.tier') && active.closest('.tier').getAttribute('data-tier-img');
      var ad = form.querySelector('[data-addon]:checked');
      if (ad && (q === 0 || focusAddon)) { img = ad.closest('.tier').getAttribute('data-tier-img') || img; }
      var main = document.querySelector('[data-gallery-main]');
      if (swapImg && img && main && main.getAttribute('src') !== img) {
        main.removeAttribute('srcset'); main.src = img;
        document.querySelectorAll('.gallery__thumb').forEach(function (b) { b.removeAttribute('aria-current'); });
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { swapImg = true; focusAddon = false; qtyInput.value = r.value; update(); });
      var tile = r.closest('.tier');
      if (tile) tile.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        swapImg = true; focusAddon = false; if (!r.checked || qtyInput.value !== r.value) { r.checked = true; qtyInput.value = r.value; } update();
      });
    });
    form.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var cur = parseInt(qtyInput.value, 10); if (isNaN(cur)) cur = 1;
        var v = cur + parseInt(b.getAttribute('data-qty-step'), 10);
        qtyInput.value = Math.max(0, Math.min(999, v));
        swapImg = true; focusAddon = false; update();
      });
    });
    qtyInput.addEventListener('input', function () { swapImg = true; focusAddon = false; update(); });
    // Menge aus dem Link übernehmen (?menge=3)
    try {
      var m = parseInt(new URLSearchParams(window.location.search).get('menge'), 10);
      var sp = new URLSearchParams(window.location.search);
      if (sp.get('pen') === '1') { form.querySelectorAll('[data-addon]').forEach(function (a) { a.checked = true; }); swapImg = true; }
      if (m >= 0 && m < 1000) { qtyInput.value = m; swapImg = true; }
    } catch (e) {}
    form.querySelectorAll('[data-addon]').forEach(function (a) { a.addEventListener('change', function () { swapImg = true; focusAddon = a.checked; update(); }); });
    // Mit Zusatzprodukt: beides zusammen in den Warenkorb legen
    form.addEventListener('submit', function (e) {
      var extra = Array.prototype.filter.call(form.querySelectorAll('[data-addon]'), function (a) { return a.checked; });
      var tierVar = tiers.some(function (t) { return t.v; });
      if ((!extra.length && !tierVar) || !window.fetch) return;
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]'); if (btn) btn.disabled = true;
      var bq = parseInt(qtyInput.value, 10) || 0;
      var items = bq > 0 ? [{ id: variantFor(bq), quantity: bq }] : [];
      extra.forEach(function (a) { items.push({ id: parseInt(a.value, 10), quantity: 1 }); });
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw r; window.location.href = root + 'cart'; })
        .catch(function () { if (btn) btn.disabled = false; form.submit(); });
    });
    if (variantInput && variantInput.tagName === 'SELECT') variantInput.addEventListener('change', update);
    update();
  });

  // Warenkorb: Mengen-Buttons und automatisches Aktualisieren
  document.querySelectorAll('[data-cart-form]').forEach(function (form) {
    var t;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var tierMap = (form.getAttribute('data-tier-map') || '').split(',').filter(Boolean).map(function (x) { var p = x.split(':'); return { q: parseInt(p[0], 10), v: String(p[1]) }; }).sort(function (a, b) { return a.q - b.q; });
    var tierIds = tierMap.map(function (t) { return t.v; });
    function tierVariantFor(q) { var v = null; tierMap.forEach(function (t) { if (q >= t.q) v = t.v; }); return v; }
    function post(url, data) {
      return fetch(root + url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(data) }).then(function (r) { if (!r.ok) throw r; return r.json(); });
    }
    function save(next) {
      var done = typeof next === 'function' ? next : function () { window.location.reload(); };
      var inputs = form.querySelectorAll('input[name="updates[]"]');
      // Paketwechsel: EXO-Position mit geänderter Menge auf das passende Paket umstellen
      var swaps = [];
      Array.prototype.forEach.call(inputs, function (i) {
        var q = Math.max(0, parseInt(i.value, 10) || 0);
        var v = i.getAttribute('data-variant');
        if (q > 0 && String(q) !== i.getAttribute('data-orig') && tierIds.indexOf(v) > -1) {
          var target = tierVariantFor(q);
          if (target && target !== v) swaps.push({ input: i, q: q, target: target });
        }
      });
      if (swaps.length && window.fetch) {
        form.classList.add('is-updating');
        var updates = Array.prototype.map.call(inputs, function (i) {
          var sw = swaps.filter(function (s) { return s.input === i; })[0];
          return sw ? 0 : Math.max(0, parseInt(i.value, 10) || 0);
        });
        var nt = form.querySelector('textarea[name="note"]');
        post('cart/update.js', { updates: updates, note: nt ? nt.value : undefined })
          .then(function () { return post('cart/add.js', { items: swaps.map(function (s) { return { id: parseInt(s.target, 10), quantity: s.q }; }) }); })
          .then(done, done);
        return;
      }
      var updates = Array.prototype.map.call(inputs, function (i) { return Math.max(0, parseInt(i.value, 10) || 0); });
      form.classList.add('is-updating');
      if (!window.fetch) { form.submit(); return; }
      fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates, note: (form.querySelector('textarea[name="note"]') || {}).value }) })
        .then(function (r) { if (!r.ok) throw r; done(); })
        .catch(function () { if (typeof next === 'function') next(); else form.submit(); });
    }
    form.querySelectorAll('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentElement.querySelector('input');
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-qty-step'), 10));
        clearTimeout(t); t = setTimeout(save, 400);
      });
    });
    form.querySelectorAll('input[name="updates[]"]').forEach(function (i) {
      i.addEventListener('change', function () { clearTimeout(t); t = setTimeout(save, 200); });
    });
    // Zur Kasse: offene Mengenänderung zuerst speichern, dann direkt zum Checkout
    form.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        clearTimeout(t);
        btn.disabled = true;
        var go = function () { window.location.href = root + 'checkout'; };
        if (!window.fetch) { go(); return; }
        save(go);
      });
    });
  });
})();
